import * as React from 'react';

import {Body} from 'shells/typography/body';
import {ModalHeader} from 'shells/typography/modal-header';
import {ModalSubheader} from 'shells/typography/modal-subheader';

import {CueCardStack} from '../../glossary/layout/cue-card-stack';
import {useGetCueCardsForOnboardingSidebar} from '../../onboarding/onboarding-checklist/helpers';

export function WhiteGloveThankYou() {
    const cueCards = useGetCueCardsForOnboardingSidebar();

    return (
        <div style={{maxWidth: 800}}>
            <div className='mb-16 flex align-center'>
                <div className='flex flex-dir-col mr-16'>
                    <ModalHeader>Thank you – your request is submitted!</ModalHeader>
                    <ModalSubheader as='h3'>
                        We’ll get started on this and be in touch shortly. We will be in touch soon
                        if we need any additional details from you, and reach out when we’re done.
                    </ModalSubheader>
                </div>
                <img
                    src='/include/images/import/icons/icon-white-glove_2x.png'
                    width={80}
                    height={80}
                    alt='White glove'
                />
            </div>
            <div className='pad-16 background-xlt-blue br-3'>
                <div className='mb-16'>
                    <Body size='large' isBold={true} color='dark'>
                        Explore more resources::
                    </Body>
                </div>
                <CueCardStack cards={cueCards} />
            </div>
        </div>
    );
}
